<template>
    <div
        id="sources"
        class="col-12">
        <div class="box">
            <div class="box-header">
                <h3 class="box-title">Seznam mailing list</h3>

                <div class="box-tools">
                    <form
                        class="input-group input-group-sm pull-left"
                        style="width: 150px; margin-right: 1rem"
                        @submit.prevent="search">
                        <input
                            v-model="moreParams.name"
                            type="text"
                            name="table_search"
                            class="form-control pull-right"
                            placeholder="Išči">

                        <div class="input-group-btn">
                            <button
                                type="submit"
                                class="btn btn-default">
                                <i class="fa fa-search"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div
                :class="isLoading ? 'loading' : ''"
                class="box-body table-responsive no-padding">
                <div class="loader">
                    <img
                        src="/images/spinner.svg"
                        alt="Nalagam"
                        width="200"
                        height="200">
                    <b>NALAGAM</b>
                </div>
                <vuetable
                    ref="vuetable"
                    :api-url="api_route"
                    :fields="fields"
                    :css="css.table"
                    :row-class="rowClass"
                    :initial-page="initialPage"
                    :per-page="perPage"
                    :sort-order="sortOrder"
                    :multi-sort="true"
                    :append-params="moreParams"
                    pagination-path="meta"
                    detail-row-component="mailing-list-details"
                    @vuetable:loaded="dataLoaded"
                    @vuetable:cell-clicked="onCellClicked"
                    @vuetable:pagination-data="onPaginationData"/>
            </div>
            <div class="box-footer clearfix">
                <div class="vuetable-pagination pagination pagination-sm no-margin pull-left">
                    <p>Zadetkov na stran</p>
                    <select
                        v-model="perPage"
                        @change="changePerPage">
                        <option
                            v-for="option in perPageOptions"
                            :key="option"
                            :value="option">
                            {{ option }} / stran
                        </option>
                    </select>
                </div>
                <div class="vuetable-pagination pagination pagination-sm no-margin pull-right">
                    <vuetable-pagination-info
                        ref="paginationInfo"
                        info-template="Prikazujem {from} do {to} od {total} zapisov"
                        info-class="pagination-info"/>
                    <vuetable-pagination-dropdown
                        ref="pagination"
                        :css="css.dropdownPagination"
                        page-text="stran"
                        @vuetable-pagination:change-page="onChangePage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vuetable                   from 'vuetable-2/src/components/Vuetable';
import VuetablePagination         from 'vuetable-2/src/components/VuetablePagination';
import VuetablePaginationDropdown from '../VuetablePaginationDropdownWithFirstAndLast';
import VuetablePaginationInfo     from 'vuetable-2/src/components/VuetablePaginationInfo';
import TablePagination            from '../../mixins/TablePagination';
import Table                      from '../../mixins/Table';
import TableUrlParams             from '../../mixins/TableUrlParams';
import ApiRoutes                  from '../../mixins/ApiRoutes';
import MailingListDetails         from './MailingListDetails';
import VuejsDialog                from 'vuejs-dialog';
import sl                         from 'date-fns/locale/sl';
import format                     from 'date-fns/format';

Vue.component('mailing-list-details', MailingListDetails);
Vue.use(VuejsDialog);

export default {
    name: 'MailingLists',

    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationDropdown,
        VuetablePaginationInfo
    },

    filters: {
        formatDate(value, fmt = 'D MMM YYYY') {
            return value ? format(value, fmt, {locale: sl}) : 'n/a';
        },
    },

    mixins: [
        ApiRoutes,
        Table,
        TableUrlParams,
        TablePagination
    ],

    data() {
        return {
            fields: [
                {
                    name:      'id',
                    title:     '#',
                    sortField: 'id'
                },
                {
                    name:      'app.app_name',
                    title:     'sekcija'
                },
                {
                    name:      'name',
                    title:     'ime',
                    sortField: 'name'
                },
                {
                    name:     'sources',
                    title:    'št. virov',
                    callback: value => value.length
                },
                {
                    name:  'sources',
                    title: 'št. prijavljenih',
                    callback(value) {
                        if (value.length > 0) {
                            return value.map(el => el.contacts)
                                        .reduce((totalContacts, contacts) => totalContacts + contacts);
                        } else {
                            return 0;
                        }
                    }
                }
            ],

            perPage: 12,

            css: {
                table: {
                    tableClass: 'table table-striped table-hover'
                }
            },

            filterBy: ['name', 'source']
        };
    },

    methods: {
        search() {
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },

        onChangePage(page) {
            this.$refs.vuetable.changePage(page);

            this.dataLoading();
        },
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MailingLists/MailingLists.vue